<template>
  <div class="mb-5">
    <div class="mt-5 row">
      <div class="mx-auto col-lg-9 col-xs-12">
        <b-breadcrumb :items="items"></b-breadcrumb>
        <div class="card">
          <div class="card-header">Exportar Dados Cesta - Mercado</div>
          <div class="card-body p-3">
            <div class="alert alert-success fs-6" v-if="sucesso.length">
              <ul class="list-unstyled">
                <li v-for="(s, i) in sucesso" :key="i">{{ s }}</li>
              </ul>
            </div>
            <div class="alert alert-warning fs-6" v-if="alerta.length">
              <ul class="list-unstyled">
                <li v-for="(a, i) in alerta" :key="i">{{ a }}</li>
              </ul>
            </div>
            <div class="alert alert-danger fs-6" v-if="erro.length">
              <ul class="list-unstyled">
                <li v-for="(e, i) in erro" :key="i">{{ e }}</li>
              </ul>
            </div>
            <fieldset class="border p-3 mb-1 w-100">
              <legend class="float-none w-auto lead">Filtre por</legend>
              <b-row class="mb-2">
                <b-col cols="md-3 12">
                  <strong>Mês/Ano de Referência:</strong>
                </b-col>
                <b-col cols="md-4 12">
                  <b-form-select
                    v-model="$v.mes.$model"
                    :options="meses"
                    class="form-select"
                    :state="validarCampo('mes')"
                  >
                  </b-form-select>
                  <b-form-invalid-feedback align="left"
                    >*Obrigatório informar o mês</b-form-invalid-feedback
                  >
                </b-col>
                <b-col cols="md-1 12 text-center">
                  <span>/</span>
                </b-col>
                <b-col cols="md-4 12">
                  <b-form-input
                    class="form-control"
                    type="number"
                    v-mask="'####'"
                    v-model="$v.ano.$model"
                    placeholder="Ano"
                    :state="validarCampo('ano')"
                  ></b-form-input>
                  <b-form-invalid-feedback align="left"
                    >*Obrigatório informar o ano</b-form-invalid-feedback
                  >
                </b-col>
              </b-row>
              <!--<b-row class="mb-2 mt-3">
                <b-col cols="md-3 12">
                  <b>Período:</b>
                </b-col>
                <b-col cols="md-4 12">
                  <b-form-input
                    id="data_inicio"
                    type="date"
                    max="3000-12-31"
                    title="Data Início"
                    v-model="dataInicio"
                    @keyup.native.enter="gerarArquivo"
                  ></b-form-input>
                </b-col>
                <b-col cols="md-1 12 text-center">
                  <span>a</span>
                </b-col>
                <b-col cols="md-4 12">
                  <b-form-input
                    id="data_fim"
                    type="date"
                    max="##/##/####"
                    title="Data Fim"
                    v-model="dataFim"
                    @keyup.native.enter="gerarArquivo"
                  ></b-form-input>
                </b-col>
              </b-row>-->
              <b-row class="mt-3" align="right">
                <b-col>
                  <b-button
                    style="margin-right: 5px"
                    variant="outline-secondary"
                    @click="limpar"
                    title="Limpar filtros"
                  >
                    <font-awesome-icon :icon="['fas', 'eraser']" />
                    Limpar
                  </b-button>
                  <b-button variant="primary" @click="gerarArquivo()"
                    ><font-awesome-icon :icon="['fas', 'file-csv']" /> Gerar
                    Arquivo</b-button
                  >
                </b-col>
              </b-row>
            </fieldset>
            <fieldset class="border p-3 mb-1 w-100">
              <legend class="float-none w-auto lead">
                Arquivos Exportados
              </legend>
              <b-table
                :fields="tabela.fields"
                :items="tabela.items"
                responsive
                small
                stacked="md"
                bordered
                striped
              >
                <template v-slot:cell(data_criacao)="data">
                  {{ formataData(data.item.data_criacao) }}
                </template>
                <template v-slot:cell(acoes)="data">
                  <b-link
                    class="text-primary mr-2"
                    style="font-size: 18px"
                    @click="downloadDocumento(data.item)"
                  >
                    <font-awesome-icon
                      :icon="['fas', 'file-download']"
                      title="Editar"
                    />
                  </b-link>
                </template>
              </b-table>
              <div class="float-right">
                <b-pagination
                  align="right"
                  @change="changePaginacao()"
                  :total-rows="tabela.paginacao.total"
                  v-model="tabela.paginacao.current_page"
                  :per-page="tabela.paginacao.per_page"
                >
                </b-pagination>
              </div>
            </fieldset>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import helpers from "../../helpers";
import Paginacao from "../../models/Paginacao";
import { required } from "vuelidate/lib/validators";

export default {
  components: {},
  data() {
    return {
      items: [{ text: "Exportar Dados Cesta - Mercado", active: true }],
      mes: null,
      ano: null,
      dataInicio: null,
      dataFim: null,
      sucesso: [],
      alerta: [],
      erro: [],
      meses: [
        { value: null, text: "Selecione o mês" },
        { value: 1, text: "Janeiro" },
        { value: 7, text: "Julho" },
      ],
      tabela: {
        paginacao: new Paginacao(),
        currentPage: 1,
        items: [],
        fields: [
          {
            key: "mes_ano",
            label: "Mês/Ano Referência	",
          },
          {
            key: "nome_original",
            label: "Nome do Arquivo",
          },
          {
            key: "quantidade",
            label: "Qtd de Registros",
          },
          {
            key: "data_criacao",
            label: "Data de Criação",
          },
          {
            key: "usuario_criacao",
            label: "Usuário de Criação",
          },
          {
            key: "acoes",
            label: "Ações",
            class: "text-center",
          },
        ],
        perPage: 10,
        totalRows: 0,
      },
    };
  },

  validations: {
    mes: {
      required,
    },
    ano: {
      required,
    },
  },

  computed: {
    http() {
      return this.$store.getters.http;
    },
  },

  methods: {
    validarCampo(name) {
      const { $dirty, $error } = this.$v[name];
      if (!$dirty && $error) {
        return null;
      } else if ($dirty && $error) {
        return false;
      }
    },

    changePaginacao() {
      console.log(this.tabela.paginacao);
      this.listarDocumento();
    },

    formataData(data) {
      return helpers.formatDateHourToDateTimeBr(data);
    },

    async gerarArquivo() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.sucesso = [];
        this.alerta = [];
        this.erro = [];
        try {
          this.$store.commit("setLoading", true);
          let params = {
            mes: this.mes,
            ano: parseInt(this.ano),
            dataInicio: this.dataInicio,
            dataFim: this.dataFim,
          };
          const resp = await this.http.post(
            `/admin/export/dados-cesta-mercado`,
            params,
            {
              headers: { Authorization: `Bearer ${this.$store.getters.token}` },
            }
          );
          if (resp.status == 200 && resp.data.erro != "true") {
            this.sucesso = ["Dados exportados com sucesso"];
            helpers.downloadFile(
              resp.data,
              "dados_cesta_estudantes_mercado.csv"
            );
            this.listarDocumento();
          } else if (resp.data.erro == "true") {
            this.alerta = Object.values(resp.data.message).flat();
          }
          this.$store.commit("setLoading", false);
        } catch (error) {
          this.$store.commit("setLoading", false);
        }
      }
    },

    async listarDocumento() {
      try {
        const params = new URLSearchParams({
          paginacao: JSON.stringify(this.tabela.paginacao),
        });
        const resp = await this.http.get(`/admin/documento/lista?${params}`, {
          headers: { Authorization: `Bearer ${this.$store.getters.token}` },
        });
        if (resp.status == 200) {
          this.tabela.items = [];
          resp.data.data.data.forEach((element) => {
            element.mes_ano = element.mes + "/" + element.ano;
            this.tabela.items.push(element);
          });
          this.tabela.paginacao = new Paginacao(resp.data.data);
          this.atualizarFlagVoucher();
        }
      } catch (error) {
        this.error = error;
      }
    },

    async atualizarFlagVoucher() {
      try {
        let params = {
          mes: this.mes,
          ano: parseInt(this.ano),
        };
        await this.http.post(
          "/admin/voucher/atualizar-flag-voucher-enviado",
          params,
          {
            headers: { Authorization: `Bearer ${this.$store.getters.token}` },
          }
        );
      } catch (error) {
        this.error = error;
      }
    },

    async downloadDocumento(item) {
      try {
        this.$store.commit("setLoading", true);
        let params = {
          nome_minio: item.nome_minio,
          prefix: item.prefix,
        };
        const resp = await this.http.post(`/admin/documento/download`, params, {
          headers: { Authorization: `Bearer ${this.$store.getters.token}` },
        });
        helpers.downloadFile(resp.data, item.nome_original);
        this.$store.commit("setLoading", false);
      } catch (error) {
        this.$store.commit("setLoading", false);
        this.error = error;
      }
    },

    limpar() {
      this.mes = null;
      this.ano = null;
      this.dataInicio = null;
      this.dataFim = null;
    },
  },

  mounted() {
    this.listarDocumento();
  },
};
</script>

